module.exports = __webpack_public_path__ + "static/media/nonononotifications.b81cc52e.png";